import {
  GetCmSheetAdminFeedbacksResponse,
  UpdateCmSheetAdminFeedbacksRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetFeedbacksService = {
  async get(cmSheetId: number): Promise<GetCmSheetAdminFeedbacksResponse> {
    const response = await httpClient.get<GetCmSheetAdminFeedbacksResponse>(
      `v1/cm-sheets/${cmSheetId}/feedbacks`,
    );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCmSheetAdminFeedbacksRequest,
  ): Promise<void> {
    await httpClient.put(`v1/cm-sheets/${cmSheetId}/feedbacks`, body);
  },
  async submitDevelopmentComment(cmsheetId: number): Promise<void> {
    await httpClient.post(
      `v1/cm-sheets/${cmsheetId}/feedbacks/development-comment`,
    );
  },
};

export default CmSheetFeedbacksService;
